import { EventBuilder } from './EventBuilder';
import { v4 as uuid } from 'uuid';
import Core from '../Core/Core';
import { Views } from '../State/reducers/view';
import { getLevelIndex } from '../State/reducers/level';
import { DDNAEvents } from './Tracker';
import { TGameAreas, TransactionActionTypes, TransactionTypes } from './ResourceParamBuilder';

export interface IRealCurrency {
    realCurrencyAmount: number;
    realCurrencyType: string;
}

export interface ITransactionProduct {
    realCurrency: IRealCurrency;
}

export const defaultProduct: ITransactionProduct = {
    realCurrency: {
        realCurrencyAmount: 0,
        realCurrencyType: 'EUR',
    },
};

export interface ITransactionParams extends ITransactionActionData {
    tLevelContext: number;
    tMovesLeft: number;
    transactionID: string;
}

// passed in with event?
export interface ITransactionActionData {
    transactionType: TransactionTypes;
    tActionType: TransactionActionTypes;
    tGameArea: TGameAreas;
    productsReceived: ITransactionProduct;
}

const defaultTransactionData: ITransactionParams = {
    tLevelContext: 0,
    tMovesLeft: 0,
    transactionID: '',
    tActionType: TransactionActionTypes.BOOSTER_USE,
    transactionType: TransactionTypes.PURCHASE,
    tGameArea: TGameAreas.MAP,
    productsReceived: defaultProduct,
};

export class TransactionParamBuilder extends EventBuilder {
    private curResourceData: ITransactionActionData;

    constructor() {
        super();

        this.curResourceData = { ...defaultTransactionData };
    }

    public getCurrentResourceData() {
        return this.curResourceData;
    }

    // unused for resource
    public setParamsFromGame(resourceActionData: ITransactionActionData): void {
        const oldResourceData = this.curResourceData;
        this.curResourceData = Object.assign(oldResourceData, resourceActionData);
    }

    public getParams<T>(
        event: DDNAEvents,
        transactionActionData: ITransactionActionData
    ): ITransactionParams {
        const state = Core.store.getState();
        return {
            ...transactionActionData,
            tLevelContext:
                state.StateView === Views.GAME
                    ? getLevelIndex(state.StateLevel.levelId)
                    : state.StateLevel.prelevel !== ''
                        ? getLevelIndex(state.StateLevel.prelevel)
                        : 0,
            tMovesLeft:
                state.StateView === Views.GAME ? state.StateBoard.availableMatches.length : 0,
            transactionID: uuid(),
        };
    }

    // unused for resource
    public setParams(keys: Map<string, any>): void {
        keys.forEach(key => {
            if (this.curResourceData.hasOwnProperty(key)) {
                const c: any = this.curResourceData;
                c[key] = keys.get(key);
            }
        });
    }
}
